import { arrayOf, exact, number, string } from 'prop-types';

import { LatLngType } from './point.type';

// [southWest, northEast]
export const MaxBoundsType = arrayOf(LatLngType);

export const ZoomType = exact({
  current: number.isRequired,
  max: number.isRequired,
  min: number.isRequired,
});

export const MapType = exact({
  center: LatLngType.isRequired,
  maxBounds: MaxBoundsType.isRequired,
  tiles: string.isRequired,
  zoom: ZoomType.isRequired,
});
